<template>
  <b-col cols="12" class="padding-0 margin-bottom-16">
    <div class="font-size-14 color-complementary-400 margin-bottom-8">
      {{ label }}
    </div>
    <div v-for="(item, index) in items" :key="`a-${index}`">
      <div
        class="font-size-12 color-complementary-300 margin-bottom-8 padding-right-10"
      >
        {{ `${index + 1}- ${item.label}: ${item.value}` }}
      </div>
      <div
        v-for="(child, childIndex) in item.children"
        :key="`b-${childIndex}`"
        class="font-size-12 color-complementary-300 margin-bottom-8 padding-right-10"
      >
        {{ `${child.label}: ${child.value}` }}
      </div>
      <div
        v-if="pathOr([], ['relations'], item).length"
        class="font-size-14 color-complementary-400 margin-bottom-8 padding-right-10"
      >
        {{ $lang.person_rel }}
      </div>
      <div
        v-for="(relation, relationIndex) in item.relations"
        :key="`c-${relationIndex}`"
        class="font-size-12 color-complementary-300 margin-bottom-8 padding-right-20"
      >
        <div
          v-for="(relItem, relIndex) in relation.children"
          :key="`d-${relIndex}`"
          class="font-size-12 color-complementary-300 margin-bottom-8"
        >
          {{ !relIndex ? `${relIndex + 1}- ` : "" }}
          {{ `${relItem.label}: ${relItem.value}` }}
        </div>
      </div>
    </div>
  </b-col>
</template>

<script>
import { toRefs } from "vue";
import { pathOr } from "ramda";
export default {
  props: {
    label: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  methods: { pathOr },
  setup(props) {
    // generate props data
    const { label, items } = toRefs(props);

    // return data to be used in template
    return { label, items };
  },
};
</script>
